<app-dialog-header [title]="'Alterações pendentes'"></app-dialog-header>

<mat-dialog-content>
  <div class="container">
    <div class="row my-2">
      <div class="col">
        <div class="form-group">
          <label class="form-label">Nome do banco</label>
          <input type="text" class="form-control" [value]="changes.bank_name" readonly />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="form-label">Código Banco</label>
          <input type="text" class="form-control" [value]="changes.bank_code" readonly />
        </div>
      </div>
    </div>

    <div class="row my-2">
      <div class="col-3">
        <div class="form-group">
          <label class="form-label">Agência</label>
          <input type="text" class="form-control" [value]="changes.agency" readonly />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [value]="changes.account_number" readonly />
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label class="form-label">Dígito</label>
          <input type="text" class="form-control" [value]="changes.account_digit" readonly />
        </div>
      </div>
    </div>

    <div class="row my-2">
      <div class="col">
        <div class="form-group">
          <label class="form-label">Nome proprietário</label>
          <input type="text" class="form-control" [value]="changes.account_holder" readonly />
        </div>
      </div>
    </div>

    <div class="row my-2">
      <div class="col">
        <div class="form-group">
          <label class="form-label">Chave Pix</label>
          <input type="text" class="form-control" [value]="changes.pix_key" readonly />
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button styleType="outlined" (btnClick)="dialogRef.close()">Fechar</app-button>
</mat-dialog-actions>
